export const WhatsApp20Regular = () => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="-2 -2 20 20"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C6.72679 16 5.49591 15.7018 4.38669 15.1393L4.266 15.075L0.621091 15.9851C0.311269 16.0625 0.0262241 15.8369 0.00130987 15.5438L0.00114131 15.4624L0.0149329 15.3787L0.925 11.735L0.86169 11.6153C0.406602 10.7186 0.124331 9.74223 0.0327466 8.72826L0.00737596 8.34634L0 8C0 3.58172 3.58172 0 8 0ZM8 1C4.13401 1 1 4.13401 1 8C1 9.21704 1.31054 10.3878 1.89352 11.4249C1.94046 11.5084 1.9621 11.603 1.95692 11.6973L1.94274 11.7912L1.187 14.812L4.21104 14.0583C4.27294 14.0429 4.33662 14.0396 4.39873 14.0479L4.4903 14.0691L4.57701 14.1075C5.61362 14.6898 6.7837 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1Z"
				fill="currentColor"
			/>
			<path
				d="M6.59891 4.63901L7.22678 5.34362C7.50038 5.65067 7.55892 6.10095 7.37151 6.45686L6.84997 7.44725C7.04537 7.8677 7.33779 8.24781 7.72723 8.58757C8.11668 8.92733 8.54292 9.1742 9.00595 9.32818L9.82506 8.70724C10.1355 8.47187 10.5622 8.47681 10.8838 8.71948L11.6331 9.28484C12.007 9.56693 12.1336 10.088 11.9293 10.5039L11.7103 10.9496C11.4923 11.3932 11.0612 11.6735 10.5786 11.6853C9.43915 11.7131 8.16821 11.0799 6.76579 9.78566C5.36133 8.48955 4.5987 7.24449 4.47791 6.0505C4.42709 5.54809 4.63311 5.06445 5.01947 4.77914L5.40913 4.4914C5.77425 4.22178 6.28341 4.28495 6.59891 4.63901Z"
				fill="currentColor"
			/>
		</svg>
	);
};
